module.exports = __webpack_public_path__ + "static/3-ccdade65d0e3b2460ee59da4c094c4f8.png";